import isEmpty from 'lodash/isEmpty';
import {   ReactNode,useEffect,
} from 'react';

import useErrorReportingStore from '../../store/errorReportingStore/useErrorReportingStore';
import useFeatureStore from '../../store/featureStore/useFeatureStore';
import useLeadChannelStore from '../../store/leadChannelStore/useLeadChannelStore';
import useUserStore from '../../store/userStore/useUserStore';

const ErrorReportingGuard = ({
  children,
}: {
  children: ReactNode;
}): ReactNode => {
  const { user } = useUserStore();
  const { lastInteractedFlags } = useFeatureStore();
  const {
    computed: { brand },
  } = useLeadChannelStore();
  const { setAdditionalData, setUser } = useErrorReportingStore();

  useEffect((): void => {
    if (user) {
      setUser({ id: user.id, email: user.primaryEmailAddress });
    }
  }, [user]);

  useEffect((): void => {
    if (!isEmpty(lastInteractedFlags)) {
      setAdditionalData(lastInteractedFlags);
    }
  }, [lastInteractedFlags]);

  useEffect((): void => {
    setAdditionalData({ brand });
  }, [brand]);

  return children;
};

export default ErrorReportingGuard;
